import { Button, Tooltip } from "@kaltura/ds-react-components";
import { GenAI24Icon } from "@kaltura/ds-react-icons";
import { useSidebarLayoutContext } from "@kaltura/ds-react-layouts";
import { translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { Theme } from "@mui/material";
import { GenieSidebarButton } from "./GenieSidebarButton";

/*
 * Genie header button
 * renders a button in the header that opens the genie side panel
 * used in ds pages
 */
export const GenieHeaderButton = () => {
    const { isOpened, setIsOpened, setActiveButtonId } = useSidebarLayoutContext();
    const isSmallScreen = useMediaQuery<Theme>((theme) => theme.breakpoints.down(theme.breakpoints.values.md));
    const toggleSidePanel = () => {
        setActiveButtonId(GenieSidebarButton.id);
        setIsOpened(!isOpened);
    };
    return (
        <Tooltip title={isSmallScreen ? translate("Ask anything") : ""} placement="bottom-start">
            <Button
                variant="borderless"
                color="translucent"
                startIcon={<GenAI24Icon />}
                onClick={toggleSidePanel}
                data-testId={"genie-header-button"}
            >
                {!isSmallScreen && translate("Ask anything")}
            </Button>
        </Tooltip>
    );
};
